export enum ErrorCode {
  auth_token_expired = 'auth_token_expired',
  auth_token_invalid = 'auth_token_invalid',
}
